module.exports = __webpack_public_path__ + "static/media/hero.d42d6c74.jpg";